import React from 'react';
import { Collapse as AntCollapse } from 'antd';
import { CaretRight } from '@nackle/origami-icons';
/**
 * A styled collapse component
 *
 * {@link https://ant.design/components/collapse#api}
 *
 * @module Collapse
 * @param {Object} props - The component props
**/

const Collapse = ( { ...props } ) => {
    return (
        <AntCollapse expandIcon={ ( { isActive } ) => CaretRightRotate( isActive ) } { ...props }></AntCollapse>
    );
};
const CaretRightRotate = ( isActive ) => {
    return ( <CaretRight className={ isActive ? 'rotate' : '' } /> );
};


export { Collapse };
